import { Link } from "react-router-dom";
import { Lock, Truck } from "lucide-react";
import { useCart, useSite } from "@/context/Providers";
import { money } from "@/lib/api";

export const CartSummary = () => {
  const { subtotal, count, setOpen } = useCart();
  const site = useSite();
  const min = site?.free_delivery_minimum ?? 50;
  const left = Math.max(0, min - subtotal);
  return (
    <div className="space-y-4" data-testid="cart-summary">
      <div className="rounded-2xl border border-line bg-raised p-4">
        <p className="flex items-center gap-2 text-sm text-gray-300"><Truck className="h-4 w-4 text-jade" aria-hidden />
          {left > 0 ? <>Add <strong className="text-white">{money(left)}</strong> more for free delivery</> : <strong className="text-jade-soft">You qualify for free delivery</strong>}
        </p>
        <div className="mt-3 h-1.5 overflow-hidden rounded-full bg-line" aria-hidden><div className="h-full rounded-full bg-jade transition-[width] duration-500" style={{ width: `${Math.min(100, (subtotal / min) * 100)}%` }} /></div>
      </div>
      <div className="flex items-center justify-between text-base">
        <span className="text-gray-300">Subtotal ({count} item{count === 1 ? "" : "s"})</span>
        <span className="font-semibold text-white" data-testid="cart-subtotal">{money(subtotal)}</span>
      </div>
      <p className="text-xs text-gray-500">Pay cash on delivery. Valid 21+ ID required.</p>
      <Link to="/checkout/" onClick={() => setOpen(false)} className="btn-gold w-full" data-testid="cart-checkout-button">
        <Lock className="h-4 w-4" aria-hidden />Proceed to Checkout
      </Link>
    </div>
  );
};
